import { Button } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { PlayIcon } from "../../../../../../resource/icons";
import { createNoticePopupState } from "../../../../store/actions/actions";
import createNotice from "../../../../store/thunks/createNotice";
import getNoticesPreview from "../../../../store/thunks/getNoticesPreview";
import playNotice from "../../../../store/thunks/playNotice";

const PlayConfirm = ({ setPlayConfirm, setLoading }) => {
	const dispatch = useDispatch();
	const { fileId } = useParams();
	const history = useHistory();
	 const location = useLocation();

	const params = new URLSearchParams(location.search);
  const companyIdFromUrl = params.get('companyId');

	return (
		<div className="confirm_container">
			<span className="confirm_title">
				Необходимо подтведить отправку оповещения
			</span>
			<div>
				<Button
					className="play button button_confirm"
					onClick={async () => {
						setLoading(true);
						const noticeId = await dispatch(createNotice());
						setLoading(false);
						setPlayConfirm(false);
						dispatch(createNoticePopupState({ popupOpened: false }));
						if (noticeId) {
							await dispatch(playNotice(noticeId));
						}
						dispatch(getNoticesPreview(fileId));
						history.push({
							pathname: `/Debts/file/${fileId}/notice/${noticeId}`,
							search: `?companyId=${companyIdFromUrl}`,
						});
					}}
				>
					<PlayIcon />
					Запустить оповещение
				</Button>
				<Button
					className="reject button button_confirm"
					onClick={() => setPlayConfirm(false)}
				>
					Отмена
				</Button>
			</div>
		</div>
	);
};

export default PlayConfirm;
